import React from "react";
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import './loader.svg'
import './style.scss'
const PortfolioItem = ({images, link}) => {
    const [details, setDetails] = React.useState(null)
    const [loaded, setLoaded] = React.useState([])
    const [currentSlide, setCurrentSlide] = React.useState(0)

    const [sliderRef] = useKeenSlider({
        loop: true,
        animationEnded(s) {
            setCurrentSlide(s.track.details.rel)
        },
        detailsChanged(s) {
          setDetails(s.track.details)
        },
        initial: 0,
    })

    React.useEffect(() => {
        const new_loaded = [...loaded]
        new_loaded[currentSlide] = true
        setLoaded(new_loaded)
      }, [currentSlide])

    function scaleStyle(idx) {
        if (!details) return {}
        const slide = details.slides[idx]
        const scale_size = 0.7
        const scale = 1 - (scale_size - scale_size * slide.portion)
        return {
            transform: `scale(${scale})`,
            WebkitTransform: `scale(${scale})`,
        }
    }
    return (
        <div ref={sliderRef} className="keen-slider zoom-out">
            {
                images.map( (src, id) => (
                    <div className="keen-slider__slide zoom-out__slide lazy__slide"
                    >
                        <div
                            style={scaleStyle(id)}
                            className={"lazy__slide"}
                        >
                        {/* <a
                            target="_blank"
                            rel="noreferrer"
                            href={link}
                            key={id}
                        > */}
                            <img src={loaded[id] ? src : ""} alt=""/>
                        {/* </a> */}
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
export default PortfolioItem
